import { useDefaultInputLanguages } from '@/hooks/useDefaultInputLanguage';
import { useCurrentSessionId } from '@heidi/runtime/shell';
import { type LanguageCode } from '@heidi/schema/ml-scribe';
import { useQuerySessionById } from '@heidi/session/data';
import { useMemo } from 'react';

export function useCurrentInputLanguages(): LanguageCode[] {
  const sessionId = useCurrentSessionId();
  const defaultInputLanguages = useDefaultInputLanguages();

  const { data: session } = useQuerySessionById({
    sessionId,
    select: (data) => {
      if (!data) return undefined;
      return {
        language_code: data.language_code,
        language_code_list: data.language_code_list,
      };
    },
  });

  const sessionLanguageCodeList = session?.language_code_list;
  const sessionLanguageCode = session?.language_code;

  return useMemo((): LanguageCode[] => {
    // Priority 1: Session's language_code_list if it exists and has length > 0
    if (sessionLanguageCodeList && sessionLanguageCodeList.length > 0) {
      return sessionLanguageCodeList;
    }

    // Priority 2: Session's language_code converted to array
    if (sessionLanguageCode) {
      return [sessionLanguageCode];
    }

    // Priority 3: User's default_input_language_code_list as fallback
    if (defaultInputLanguages && defaultInputLanguages.length > 0) {
      return defaultInputLanguages;
    }

    // Default: empty array if nothing is available
    return [];
  }, [sessionLanguageCodeList, sessionLanguageCode, defaultInputLanguages]);
}
